

import { QueryRequestProvider } from './contact-details/core/QueryRequestProvider'
import { QueryResponseProvider } from './contact-details/core/QueryResponseProvider'
import { ListViewProvider, useListView } from './contact-details/core/ListViewProvider'
import { KTCard } from '../../../_dashboard/helpers'
import { Contact } from './Contact'

const ContactComponent = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
     <Contact/>
      </KTCard>
    </>
  )
}

const ContactListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ContactComponent />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {ContactListWrapper}
